export default defineAppConfig({
  site: {
    orgName: 'Szkoła Biblijna',
    logoLines: { line1: 'SZKOŁA', line2: 'BIBLIJNA' },
    defaultCountryIso: 'pl',
    geoDetect: false,
    showRegionField: false,
    showExpertsSection: false,
    phone: '+375 33 677 16 77',
    phoneTel: '+375336771677',
    email: null as string | null,
    supportUrl: null as string | null,
  },
})
